import { render, staticRenderFns } from "./UserPwd.vue?vue&type=template&id=4676b3ce&scoped=true&"
import script from "./UserPwd.vue?vue&type=script&lang=js&"
export * from "./UserPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676b3ce",
  null
  
)

export default component.exports